import { GatewayCustomerModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/customers/models/outputs/gateway-customer.model';
import { HeaderContext } from '@tanstack/react-table';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface CustomerListHolderFullNameHeaderProps
  extends HeaderContext<GatewayCustomerModel, GatewayCustomerModel['holder']> {}

export const CustomerListHolderFullNameHeader =
  (): // props: CustomerListHolderFullNameHeaderProps,
  ReactNode => {
    // CONTEXT ///////////////////////////////////////////////////////////////////

    const { t } = useTranslation();

    // RENDER ////////////////////////////////////////////////////////////////////

    return t('delmonicos-shared-sdk.outputs-customer.holder');
  };
